import { a } from "@react-spring/web";
import { BeanHead } from "beanheads";
import { useEffect, useState } from "react";
import "../../../style/components/auth/StudentAccount/AvatarView.css";
import {
  FaEdit,
  FaCheck,
  FaTimes,
  FaChevronRight,
  FaChevronLeft,
  FaToggleOff,
  FaToggleOn,
} from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import { updateStudentAvatar } from "../../../firebase-functions/database";
import { auth } from "../../../firebase-functions/config";

export const AvatarView = (props) => {
  //     accessory    enum('none', 'roundGlasses', 'tinyGlasses', 'shades')

  //faceMaskColor enum('white', 'blue', 'black', 'green', 'red')
  // clothing enum( 'shirt', 'dressShirt', 'vneck', 'tankTop', 'dress')
  // clothingColor enum('white', 'blue', 'black', 'green', 'red')
  // eyebrows enum('raised', 'leftLowered', 'serious', 'angry', 'concerned')
  // eyes enum('normal', 'leftTwitch', 'happy', 'content', 'squint', 'simple', 'dizzy', 'wink', 'heart')
  // facialHair enum('none', 'none2', 'none3', 'stubble', 'mediumBeard')

  // hair enum('none', 'long', 'bun', 'short', 'pixie', 'balding', 'buzz', 'afro', 'bob')
  // hairColor enum('blonde', 'orange', 'black', 'white', 'brown', 'blue', 'pink')
  // hat enum('none', 'none2', 'none3', 'none4', 'none5', 'beanie', 'turban')
  // hatColor enum('white', 'blue', 'black', 'green', 'red')
  // lashes enum('true', 'false')
  // lipColor enum('red', 'purple', 'pink', 'turqoise', 'green')
  // mask boolean
  // faceMask boolean
  // mouth enum('grin', 'sad', 'openSmile', 'lips', 'open', 'serious', 'tongue')
  // skinTone enum('light', 'yellow', 'brown', 'dark', 'red', 'black')

  const VALUES = {
    accessory: ["none", "roundGlasses", "tinyGlasses", "shades"],

    clothing: ["shirt", "dressShirt", "vneck", "tankTop", "dress"],
    clothingColor: ["white", "blue", "black", "green", "red"],
    eyebrows: ["raised", "leftLowered", "serious", "angry", "concerned"],
    eyes: [
      "normal",
      "leftTwitch",
      "happy",
      "content",
      "squint",
      "simple",
      "dizzy",
      "wink",
      "heart",
    ],
    facialHair: ["none", "none2", "none3", "stubble", "mediumBeard"],

    hair: [
      "none",
      "long",
      "bun",
      "short",
      "pixie",
      "balding",
      "buzz",
      "afro",
      "bob",
    ],
    hairColor: ["blonde", "orange", "black", "white", "brown", "blue", "pink"],
    hat: ["none", "none2", "none3", "none4", "none5", "beanie", "turban"],
    hatColor: ["white", "blue", "black", "green", "red"],
    lashes: ["true", "false"],
    lipColor: ["red", "purple", "pink", "turqoise", "green"],
    mask: ["true", "false"],
    faceMask: ["true", "false"],
    faceMaskColor: ["white", "blue", "black", "green", "red"],
    mouth: ["grin", "sad", "openSmile", "lips", "open", "serious", "tongue"],
    skinTone: ["light", "yellow", "brown", "dark", "red", "black"],
  };

  const VALUESTOAVOID = ["mask", "lashes", "faceMask"];
  const VALUENAMES = Object.keys(VALUES).filter(
    (key) => !VALUESTOAVOID.includes(key)
  );
  const avatarInfo = props.avatarIndo && props.avatarInfo !== undefined;

  const [activeProp, setActiveProp] = useState(Object.keys(VALUES)[0]);
  const [editMode, setEditMode] = useState(false);

  const [accessory, setAccessory] = useState(VALUES.accessory[0]);

  const [clothing, setClothing] = useState(VALUES.clothing[0]);
  const [clothingColor, setClothingColor] = useState(VALUES.clothingColor[0]);
  const [eyebrows, setEyebrows] = useState(VALUES.eyebrows[0]);
  const [eyes, setEyes] = useState(VALUES.eyes[0]);
  const [facialHair, setFacialHair] = useState(VALUES.facialHair[0]);

  const [hair, setHair] = useState(VALUES.hair[0]);
  const [hairColor, setHairColor] = useState(VALUES.hairColor[0]);
  const [hat, setHat] = useState(VALUES.hat[0]);
  const [hatColor, setHatColor] = useState(VALUES.hatColor[0]);
  const [lashes, setLashes] = useState(VALUES.lashes[0]);
  const [lipColor, setLipColor] = useState(VALUES.lipColor[0]);
  const [mask, setMask] = useState(VALUES.mask[0]);
  const [faceMask, setFaceMask] = useState(VALUES.faceMask[0]);
  const [faceMaskColor, setFaceMaskColor] = useState(VALUES.faceMaskColor[0]);
  const [mouth, setMouth] = useState(VALUES.mouth[0]);
  const [skinTone, setSkinTone] = useState(VALUES.skinTone[0]);

  const convertCamelCaseToTitleCaseWithSpaces = (str) => {
    const spaced = str
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // space before caps
      .replace(/([A-Za-z])([0-9])/g, "$1 $2") // space before numbers
      .replace(/([0-9])([A-Za-z])/g, "$1 $2"); // space after numbers

    // Capitalize each word
    return spaced
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const randomizeAvatar = () => {
    setAccessory(
      VALUES.accessory[Math.floor(Math.random() * VALUES.accessory.length)]
    );
    setClothing(
      VALUES.clothing[Math.floor(Math.random() * VALUES.clothing.length)]
    );
    setClothingColor(
      VALUES.clothingColor[
        Math.floor(Math.random() * VALUES.clothingColor.length)
      ]
    );
    setEyebrows(
      VALUES.eyebrows[Math.floor(Math.random() * VALUES.eyebrows.length)]
    );
    setEyes(VALUES.eyes[Math.floor(Math.random() * VALUES.eyes.length)]);
    setFacialHair(
      VALUES.facialHair[Math.floor(Math.random() * VALUES.facialHair.length)]
    );
    setHair(VALUES.hair[Math.floor(Math.random() * VALUES.hair.length)]);
    setHairColor(
      VALUES.hairColor[Math.floor(Math.random() * VALUES.hairColor.length)]
    );
    setHat(VALUES.hat[Math.floor(Math.random() * VALUES.hat.length)]);
    setHatColor(
      VALUES.hatColor[Math.floor(Math.random() * VALUES.hatColor.length)]
    );
    setLashes(VALUES.lashes[Math.floor(Math.random() * VALUES.lashes.length)]);
    setLipColor(
      VALUES.lipColor[Math.floor(Math.random() * VALUES.lipColor.length)]
    );
    setMask(VALUES.mask[Math.floor(Math.random() * VALUES.mask.length)]);
    setFaceMask(
      VALUES.faceMask[Math.floor(Math.random() * VALUES.faceMask.length)]
    );
    setFaceMaskColor(
      VALUES.faceMaskColor[
        Math.floor(Math.random() * VALUES.faceMaskColor.length)
      ]
    );
    setMouth(VALUES.mouth[Math.floor(Math.random() * VALUES.mouth.length)]);
    setSkinTone(
      VALUES.skinTone[Math.floor(Math.random() * VALUES.skinTone.length)]
    );
  };

  const updateAvatarInfo = () => {
    const avatarData = {
      accessory,
      clothing,
      clothingColor,
      eyebrows,
      eyes,
      facialHair,
      hair,
      hairColor,
      hat,
      hatColor,
      lashes,
      lipColor,
      mask,
      faceMask,
      faceMaskColor,
      mouth,
      skinTone,
    };

    updateStudentAvatar(
      auth.currentUser.uid,
      avatarData,
      auth.currentUser
    ).then((res) => {
      if (res.success) {
        toast.success("Avatar updated successfully");
        setEditMode(false);
      } else {
        toast.error("Failed to update avatar");
      }
    });
  };

  useEffect(() => {
    if (props.avatarInfo) {
      setAccessory(props.avatarInfo.accessory);
      setClothing(props.avatarInfo.clothing);
      setClothingColor(props.avatarInfo.clothingColor);
      setEyebrows(props.avatarInfo.eyebrows);
      setEyes(props.avatarInfo.eyes);
      setFacialHair(props.avatarInfo.facialHair);
      setHair(props.avatarInfo.hair);
      setHairColor(props.avatarInfo.hairColor);
      setHat(props.avatarInfo.hat);
      setHatColor(props.avatarInfo.hatColor);
      setLashes(props.avatarInfo.lashes);
      setLipColor(props.avatarInfo.lipColor);
      setMask(props.avatarInfo.mask);
      setFaceMask(props.avatarInfo.faceMask);
      setFaceMaskColor(props.avatarInfo.faceMaskColor);
      setMouth(props.avatarInfo.mouth);
      setSkinTone(props.avatarInfo.skinTone);
    }
  }, [avatarInfo, props.avatarInfo]);

  return (
    <div
      className={
        "avatar-view " +
        (props.isLogin
          ? props?.isMobile
            ? " login-avatar login-avatar-mobile"
            : "login-avatar"
          : "")
      }
    >
      <ToastContainer />
      {editMode && <h2> Edit Avatar</h2>}
      <BeanHead
        height={props.isLogin ? 100 : 200}
        width={props.isLogin ? 100 : 200}
        accessory={accessory}
        body={"chest"}
        clothing={clothing}
        clothingColor={clothingColor}
        eyebrows={eyebrows}
        eyes={eyes}
        facialHair={facialHair}
        graphic={"none"}
        hair={hair}
        hairColor={hairColor}
        hat={hat}
        hatColor={hatColor}
        lashes={lashes === "true"}
        lipColor={lipColor}
        mask={mask === "true"}
        faceMask={faceMask === "true"}
        faceMaskColor={faceMaskColor}
        mouth={mouth}
        skinTone={skinTone}
      />
      {editMode && (
        <div className="avatar-edit-option">
          <div className="randomize-avatar">
            <button onClick={randomizeAvatar}>Random Avatar</button>
          </div>
          <div className="prop-navigation">
            <button
              onClick={() => {
                const currentIndex = VALUENAMES.indexOf(activeProp);
                const prevIndex =
                  (currentIndex - 1 + VALUENAMES.length) % VALUENAMES.length;

                setActiveProp(VALUENAMES[prevIndex]);
              }}
            >
              <FaChevronLeft />
            </button>
            <p>{convertCamelCaseToTitleCaseWithSpaces(activeProp)}</p>
            <button
              onClick={() => {
                const currentIndex = VALUENAMES.indexOf(activeProp);
                const nextIndex = (currentIndex + 1) % VALUENAMES.length;

                setActiveProp(VALUENAMES[nextIndex]);
              }}
            >
              <FaChevronRight />
            </button>
          </div>
          <div className="prop-options">
            {VALUES[activeProp].map((value) => (
              <button
                key={value}
                className={`prop-option ${
                  value === eval(activeProp) ? "active" : ""
                }`}
                onClick={() => {
                  eval(
                    `set${
                      activeProp.charAt(0).toUpperCase() + activeProp.slice(1)
                    }('${value}')`
                  );
                }}
              >
                {convertCamelCaseToTitleCaseWithSpaces(value)}
              </button>
            ))}
          </div>
        </div>
      )}

      {editMode && (
        <div className="avatar-switches">
          {VALUESTOAVOID.map((prop) => (
            <div key={prop} className="switch-option">
              <label htmlFor={prop}>
                {prop === "mask"
                  ? "Background Circle"
                  : convertCamelCaseToTitleCaseWithSpaces(prop)}
              </label>
              <span
                className="switch-icon"
                title={eval(prop)}
                onClick={() => {
                  eval(
                    `set${prop.charAt(0).toUpperCase() + prop.slice(1)}('${
                      eval(prop) === "true" ? "false" : "true"
                    }')`
                  );
                }}
              >
                {eval(prop) === "true" ? <FaToggleOn /> : <FaToggleOff />}
              </span>
            </div>
          ))}
        </div>
      )}
      {!props.isLogin && (
        <div className="avatar-controls">
          {editMode ? (
            <>
              <button
                onClick={() => {
                  setEditMode(false);
                  updateAvatarInfo();
                }}
              >
                <FaCheck /> Done
              </button>
              <button onClick={() => setEditMode(false)}>
                <FaTimes /> Cancel
              </button>
            </>
          ) : (
            <button onClick={() => setEditMode(true)}>
              <FaEdit /> Edit Avatar
            </button>
          )}
        </div>
      )}
    </div>
  );
};
